// extracted by mini-css-extract-plugin
export default {"sorts":"styles_sorts__Mhc7q","item":"styles_item__9Z2t2","label":"styles_label__lyi3y","active":"styles_active__vOZnZ"};